import React from 'react'
import PropTypes from 'prop-types'

import './tabs.scss'

class Tab extends React.Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }

  onClick = () => {
    const { label, onClick } = this.props
    onClick(label)
  }

  render() {
    const {
      onClick,
      props: { activeTab, label, disabled, hide },
    } = this

    let className = 'tabs__items'

    if (activeTab === label) {
      className += ' tabs__items--active'
    }

    if (disabled) {
      className += ' tabs__items--disabled'
    }

    if (hide) {
      className += ' tabs__items--hide'
    }

    return (
      <div
        className={className}
        onClick={onClick}
        onKeyDown={onClick}
        role="tab"
        tabIndex={0}
      >
        {label}
      </div>
    )
  }
}

export default Tab
